import React, { useState } from "react";
import { ChevronDown, LifeBuoy } from "lucide-react";
import Modal from "@/components/chat/Modal";
import { useI18n } from "@/context/I18nContext";

const QA = {
  fr: [
    ["Comment installer RoyalChat Nova sur mon téléphone ?", "Ouvrez le site dans Chrome (Android) ou Safari (iPhone), puis utilisez « Ajouter à l'écran d'accueil ». Sur la page d'accueil, le bouton « Installer » vous guide aussi."],
    ["Mes messages ne partent pas, que faire ?", "RoyalChat Nova garde vos messages en file d'attente hors-ligne et les envoie automatiquement dès que la connexion revient. Vérifiez votre réseau."],
    ["Comment activer l'assistant IA ?", "Réglages → Assistant IA → ajoutez votre propre clé (Gemini, Groq ou OpenRouter). La clé reste sur votre appareil."],
    ["Les appels ne fonctionnent pas.", "Autorisez l'accès au micro et à la caméra dans votre navigateur. Sur réseau faible, la qualité s'adapte automatiquement."],
    ["Comment économiser mes données ?", "Réglages → Données & Stockage → activez « Économiseur de données » pour compresser fortement les médias."],
    ["Comment récupérer un message envoyé par erreur ?", "Activez « Annuler avant l'envoi » : une barre apparaît quelques secondes pour annuler l'envoi."],
  ],
  en: [
    ["How do I install RoyalChat Nova on my phone?", "Open the site in Chrome (Android) or Safari (iPhone), then use “Add to Home Screen”. The landing page “Install” button also guides you."],
    ["My messages won't send — what should I do?", "RoyalChat Nova queues messages offline and sends them automatically once you're back online. Check your connection."],
    ["How do I enable the AI assistant?", "Settings → AI Assistant → add your own key (Gemini, Groq or OpenRouter). The key stays on your device."],
    ["Calls aren't working.", "Allow microphone and camera access in your browser. On weak networks, call quality adapts automatically."],
    ["How do I save mobile data?", "Settings → Data & Storage → turn on “Data saver” to heavily compress media."],
    ["How can I undo a message I sent by mistake?", "Turn on “Undo before sending”: a bar appears for a few seconds so you can cancel the send."],
  ],
};

export default function HelpDialog({ onClose }) {
  const { t, lang } = useI18n();
  const [open, setOpen] = useState(0);
  const list = QA[lang === "fr" ? "fr" : "en"];
  return (
    <Modal title={t("help_support")} onClose={onClose}>
      <div className="flex items-center gap-3 mb-5 text-[var(--rc-gold)]">
        <LifeBuoy size={28} />
        <p className="text-sm text-[var(--rc-muted)]">{t("help_support_desc")}</p>
      </div>
      <div className="space-y-2" data-testid="help-qa-list">
        {list.map(([q, a], i) => (
          <div key={i} className="rounded-2xl border border-[var(--rc-border)] overflow-hidden">
            <button onClick={() => setOpen(open === i ? -1 : i)} data-testid={`help-q-${i}`}
              className="w-full flex items-center justify-between gap-3 px-4 py-3.5 text-left">
              <span className="font-medium">{q}</span>
              <ChevronDown size={18} className={`shrink-0 text-[var(--rc-muted)] transition-transform ${open === i ? "rotate-180" : ""}`} />
            </button>
            {open === i && <p className="px-4 pb-4 text-sm text-[var(--rc-muted)] leading-relaxed">{a}</p>}
          </div>
        ))}
      </div>
      <p className="mt-6 text-center text-sm text-[var(--rc-muted)]">
        {lang === "fr" ? "Besoin d'aide ? Écrivez-nous depuis « Envoyer une suggestion »." : "Need more help? Reach us via “Send a suggestion”."}
      </p>
    </Modal>
  );
}
